var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React, { useState, useEffect } from 'react';
import { Route, Switch } from 'react-router-dom';
import { useIdleTimer } from 'react-idle-timer';
import { Header } from '../sections';
import routes, { PROFILE } from '../../config/routes';
import { isAuth, signIn, signOut, authenticationToken, getTokenDuration, checkTokenAge, } from '../../shared/api/authentication';
import { services } from '../../shared';
import { Config } from '../../config/config';
import { ErrorHandling, ProfilePage, InactiveHandling } from '../../components/pages';
import { BrokerStatus, OrganisationStatus } from '../../shared/types/enums';
import '../../styles/app.scss';
import { useDispatch } from 'react-redux';
import { useCaseId } from '../../redux/componentData/caseIdFromUrlSlice';
import { useAppSelector } from './hooks';
;
export var App = function () {
    var _a, _b, _c, _d;
    var _e = useState(), broker = _e[0], setBroker = _e[1];
    var _f = useState(), theme = _f[0], setTheme = _f[1];
    var _g = useState(false), isError = _g[0], setError = _g[1];
    var _h = useState(0), idleTimeout = _h[0], setIdleTimeout = _h[1];
    var _j = useState(), adminData = _j[0], setadminData = _j[1];
    var _k = useState(), urladminData = _k[0], setUrladminData = _k[1];
    var dispatch = useDispatch();
    var isAdminCheck = (sessionStorage.getItem('urlEncryData') !== 'null' ? true : false);
    var handleOnIdle = function () {
        if (new Date(getLastActiveTime()).getTime() > (authenticationToken === null || authenticationToken === void 0 ? void 0 : authenticationToken.expiresOn.getTime())) {
            signOut();
        }
        start();
    };
    var _l = useIdleTimer({
        timeout: idleTimeout,
        onIdle: handleOnIdle,
        onActive: checkTokenAge,
    }), getLastActiveTime = _l.getLastActiveTime, start = _l.start;
    useEffect(function () {
        if (isAdminCheck === true) {
            servicecallforurl();
        }
        setIdleTimeout(getTokenDuration() / 2);
        window.onerror = function (message, source, lineno, colno, error) {
            services.logError(error);
        };
    }, [authenticationToken]);
    function servicecallforurl() {
        return __awaiter(this, void 0, void 0, function () {
            var urlParams, requestData;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(adminData === null || adminData === undefined || adminData.caseId === '' || adminData.caseId === null || adminData.caseId === undefined)) return [3 /*break*/, 2];
                        urlParams = new URLSearchParams(window.location.search);
                        requestData = urlParams.get('request');
                        if (!(requestData || requestData != undefined)) return [3 /*break*/, 2];
                        return [4 /*yield*/, services.GetDecrypt(requestData).then(function (result) {
                                if (result.data) {
                                    setUrladminData({
                                        applicationFormId: result.data.applicationFormId,
                                        applicationId: result.data.applicationId,
                                        loanPurposeId: result.data.loanPurposeId,
                                        brokerGuid: result.data.brokerGuid,
                                    });
                                }
                            })];
                    case 1:
                        _a.sent();
                        adminDataSetInRedux();
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    }
    ;
    function adminDataSetInRedux() {
        if (urladminData != undefined) {
            var applicationRequest = {
                ApplicationId: urladminData.applicationId,
                ApplicationFormId: urladminData.applicationFormId,
                LoanPurposeId: urladminData.loanPurposeId
            };
            var isAdmin_1 = applicationRequest.ApplicationId != null && applicationRequest.ApplicationId != undefined && applicationRequest.ApplicationId != 0 ? true : false;
            var admindataforredirect = ({
                caseId: applicationRequest.ApplicationId.toString(),
                isAdmin: isAdmin_1,
                formId: applicationRequest.ApplicationFormId.toString(),
                loanPurposeId: applicationRequest.LoanPurposeId.toString(),
            });
            if (admindataforredirect) {
                sessionStorage.setItem('caseId', applicationRequest.ApplicationId.toString());
                sessionStorage.setItem('formId', applicationRequest.ApplicationFormId.toString());
                sessionStorage.setItem('loanPurposeId', applicationRequest.LoanPurposeId.toString());
                sessionStorage.setItem('isAdmin', isAdmin_1.toString());
                setadminData(admindataforredirect);
            }
        }
    }
    ;
    if (adminData) {
        dispatch(useCaseId(adminData));
    }
    ;
    if (!sessionStorage.getItem('baseUrl')) {
        if (Config.baseurl === undefined) {
            sessionStorage.setItem('baseUrl', window.location.origin);
        }
        else {
            sessionStorage.setItem('baseUrl', Config.baseurl);
        }
    }
    if (!theme)
        services.getThemeUrl().then(function (result) {
            if (result) {
                result.text().then(function (content) {
                    if (content && content.length > 0) {
                        var urlCreator = window.URL || window.webkitURL;
                        setTheme(urlCreator.createObjectURL(new Blob([content], { type: 'text/css' })));
                    }
                });
            }
        });
    if (isAdminCheck === true) {
        if (adminData === null || adminData === undefined || adminData.caseId === '' || adminData.caseId === 'null' || adminData.caseId === undefined) {
            var sessionData = sessionStorage.getItem('urlEncryData');
            services.GetDecrypt(sessionData).then(function (result) {
                if (result.data) {
                    setUrladminData({
                        applicationFormId: result.data.applicationFormId,
                        applicationId: result.data.applicationId,
                        loanPurposeId: result.data.loanPurposeId,
                        brokerGuid: result.data.brokerGuid,
                    });
                }
            });
            adminDataSetInRedux();
        }
        ;
    }
    ;
    var isAdmin = useAppSelector(function (state) { return state.adminData.adminData.isAdmin; }) === false ? ((sessionStorage.getItem('urlEncryData') === 'null' || sessionStorage.getItem('urlEncryData') === undefined) ? false : true) : true;
    if (isAuth() && !broker)
        services.getBroker().then(function (user) {
            var _a;
            if (user !== null) {
                switch ((_a = user.status) !== null && _a !== void 0 ? _a : 0) {
                    case 204:
                        if (isAdmin === true ?
                            setBroker(function (prevState) {
                                return __assign(__assign({}, prevState), { name: 'Admin User' }); //This is just to prevent null while working in admin data
                            })
                            : window.location.href = Config.auth)
                            break;
                    case 400:
                        setError(true);
                        break;
                    default:
                        if (isAdmin === true) {
                            setBroker(function (prevState) {
                                return __assign(__assign({}, prevState), { name: 'Admin User' });
                            });
                        }
                        else {
                            setBroker(user === null || user === void 0 ? void 0 : user.data);
                        }
                        break;
                }
            }
        });
    try {
        return isAuth() ? (React.createElement(React.Fragment, null,
            theme && React.createElement("link", { rel: "stylesheet", href: theme, type: "text/css" }),
            React.createElement(Header, { broker: broker, firstName: (_b = (_a = broker === null || broker === void 0 ? void 0 : broker.name) === null || _a === void 0 ? void 0 : _a.split(' ')[0]) !== null && _b !== void 0 ? _b : '', lastName: (_d = (_c = broker === null || broker === void 0 ? void 0 : broker.name) === null || _c === void 0 ? void 0 : _c.split(' ')[1]) !== null && _d !== void 0 ? _d : '' }),
            React.createElement("main", null,
                broker &&
                    (broker.organisationStatusId == OrganisationStatus.Deleted ||
                        broker.organisationStatusId == OrganisationStatus.Suspended ||
                        broker.brokerStatus == BrokerStatus.Inactive ||
                        broker.brokerStatus == BrokerStatus.Suspended ||
                        broker.brokerStatus == BrokerStatus.Deleted) ? (React.createElement(InactiveHandling, null)) : (React.createElement(Switch, null, broker &&
                    broker.brokerStatus != BrokerStatus.Deleted &&
                    broker.brokerStatus != BrokerStatus.Inactive &&
                    routes.map(function (route, index) {
                        return route.id == PROFILE.id ? (React.createElement(Route, { key: "".concat(PROFILE.path, "-").concat(index), exact: true, path: PROFILE.path },
                            React.createElement(ProfilePage, { key: "".concat(route.id, "-").concat(index), broker: broker, setBroker: setBroker }))) : (React.createElement(Route, { key: "".concat(route.id, "-").concat(index), path: route.paths || route.path, component: route.component, exact: true }));
                    }))),
                isError && React.createElement(ErrorHandling, null)))) : (React.createElement(Route, { key: "route-bad-route", path: "/", render: function () {
                console.log('bad route', '/');
                signIn();
                return null;
            } }));
    }
    catch (err) {
        console.log(err);
    }
};
